export default __webpack_public_path__ + "static/media/arrow.07d58960.svg";